import { isStaff as userIsStaff } from 'utils/userEnvironment';
import { useUser } from 'zustand-stores/userEnvironmentStore';

export function useCurrentUserIsStaff() {
  const { user } = useUser();
  return user ? userIsStaff(user) : false;
}
